module.exports = __webpack_public_path__ + "img/course-icon-up.769d09d7.svg";